import React, { useEffect, useState } from 'react';
import { Icons, Box, Fade, IconButton, Popper, Typography, Button } from "@curves/ui-base";
import MemberSiteQrCodeDialog from "@icoach/components/dialog/MemberSiteQrCodeDialog";
import { useMemberProfileLineApi } from "@apis/useMemberProfileApi";
import { parseDate } from "@util/moment";
import useMessageDialog from "@util/hook/useMessageDialog";

const MemberLineBindingInfoPopup = (props) => {
    const { open, anchorEl, sourceData, onClose } = props;
    const setMessageDialog = useMessageDialog();
    const { deleteLineBindingInfoApi } = useMemberProfileLineApi();

    const {
        memberID,
        lineDisplayName,
        linePictureUrl,
        lineRoleType,
        lineBoundDate,
    } = sourceData || {};

    const handleUnbind = () => {
        setMessageDialog({
            open: true,
            title: '確認要解除綁定？',
            msg: `刪除此會員與LINE帳號[${lineDisplayName}]關聯，解除後需重新透過 Qrcode 驗證綁定帳號`,
            onAsyncConfirm: handleGoToUnbindingApi,
        });
    };

    const handleGoToUnbindingApi = () => {
        const resp = deleteLineBindingInfoApi(memberID);

        if (resp) {
            onClose();
            window.location.reload();
        }
    }

    if (!open) return null;

    return (
        <Popper open={open} anchorEl={anchorEl} transition style={{ zIndex: 11000 }}>
            {({ TransitionProps }) => (
                <Fade {...TransitionProps} timeout={350}>
                    <Box className="member-line-binding-info-tooltip">
                        <IconButton className="btn-close" onClick={onClose}>
                            <Icons.ErrorCircle />
                        </IconButton>
                        <Box className="member-line-binding-info-tooltip-wrap">
                            <img className="member-line-binding-info-tooltip-picture" src={linePictureUrl} alt="LINE 大頭照" />
                            <Box className="member-line-binding-info-tooltip-badge">
                                {lineRoleType === 2 && <Icons.UserAlt htmlColor={"#ffffff"} size="small" />}
                                {lineRoleType === 3 && <Icons.Ring htmlColor={"#ffffff"} size="small" />}
                            </Box>
                            <Typography className="member-line-binding-info-tooltip-display text-ellipsis-columns-1" variant="h6">
                                {lineDisplayName}
                            </Typography>
                            <hr />
                            <Typography variant="body2" color="gray">
                                綁定時間 {parseDate(lineBoundDate, 'YYYY-MM-DD')}
                                <br />
                            </Typography>
                            <Button className="member-line-binding-info-tooltip-unbind" color="error" variant="outlined" size="xsmall"
                                    onClick={handleUnbind}>解除綁定</Button>
                        </Box>
                    </Box>
                </Fade>
            )}
        </Popper>
    )
}

const MemberLineBindingIconButton = React.memo(
    React.forwardRef((props, ref) => {
        const {
            className,
            referenceID
        } = props;

        const [open, setOpen] = useState(false);
        const [sourceData, setSourceData] = useState({});
        const { getLineBindingInfoApi } = useMemberProfileLineApi();
        const iconRef = React.useRef(null);

        const {
            isBound,
        } = sourceData || {};

        const handleOnClose = () => {
            setOpen(false);
            if (referenceID) {
                doLineBindingInfoApi(referenceID);
            }
        };

        const handleOnClick = () => {
            setOpen(true);
        };

        const doLineBindingInfoApi = async (memberID) => {
            const resp = await getLineBindingInfoApi(memberID);
            if (resp) {
                setSourceData(resp);
            }
        }

        useEffect(
            () => {
                if (referenceID) {
                    doLineBindingInfoApi(referenceID);
                }

            },
            // eslint-disable-next-line
            [referenceID],
        )


        return (
            <React.Fragment>
                <Box className="member-line-binding-info" ref={iconRef}>
                    <IconButton className={className} color={isBound ? 'success' : ''} onClick={handleOnClick}>
                        <Icons.LineLogo />
                    </IconButton>

                </Box>

                {!isBound
                    ? <MemberSiteQrCodeDialog open={open} onClose={handleOnClose} sourceData={{ referenceID }} hideCaptcha={true} />
                    : <MemberLineBindingInfoPopup open={open} anchorEl={iconRef.current} sourceData={sourceData} onClose={handleOnClose} />
                }
            </React.Fragment>
        );
    }),
);

export default MemberLineBindingIconButton;
